"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APP_BRIDGE_ACCESS_NOT_DECLARED_MESSAGE = exports.APP_BRIDGE_ACCESS_NOT_DECLARED = exports.APP_BRIDGE_CAPABILITY_CLASS = void 0;
exports.matchesAppCapabilityDeclaration = matchesAppCapabilityDeclaration;
const app_base_binding_route_1 = require("./app-base-binding-route");
exports.APP_BRIDGE_CAPABILITY_CLASS = {
    'dataset.readWindow': 'dataSourceRead',
    'dataset.subscribe': 'dataSourceRead',
    'members.read': 'dataSourceRead',
    'database.row.insert': 'dataSourceWrite',
    'database.row.update': 'dataSourceWrite',
    'database.row.delete': 'dataSourceWrite',
    'attachment.update': 'dataSourceWrite',
    'dataset.restore': 'dataSourceWrite',
    'agentAction.invoke': 'agentAction',
    'document.export': 'agentAction',
    'automation.run': 'automation',
};
/** The refusal of a bridge call the manifest does not declare. */
exports.APP_BRIDGE_ACCESS_NOT_DECLARED = 'APP_BRIDGE_ACCESS_NOT_DECLARED';
/** Its message for the person using the App, in the page's language. */
exports.APP_BRIDGE_ACCESS_NOT_DECLARED_MESSAGE = {
    de: 'Diese App darf das nicht.',
    en: 'This app is not allowed to do that.',
};
/** Whether one manifest capability declares the access a call asks for. */
function matchesAppCapabilityDeclaration(capability, query) {
    if (query.capabilityId && capability.capabilityId !== query.capabilityId) {
        return false;
    }
    if (query.declarationId && capability.id !== query.declarationId) {
        return false;
    }
    if (query.commandId &&
        capability.id !== query.commandId &&
        !capability.actionIds.includes(query.commandId)) {
        return false;
    }
    if (query.routePath &&
        capability.routePaths.length > 0 &&
        !capability.routePaths.some(routePath => declaredRouteMatches(routePath, query.routePath))) {
        return false;
    }
    if (query.sourceKey && !capability.dataSourceKeys.includes(query.sourceKey)) {
        return false;
    }
    if (query.actionId && !capability.actionIds.includes(query.actionId)) {
        return false;
    }
    return true;
}
function declaredRouteMatches(declaredRoute, requestedRoute) {
    const declared = normalizeRoutePath(declaredRoute);
    const requested = normalizeRoutePath(requestedRoute);
    if (declared === requested)
        return true;
    const declaredSegments = declared.split('/').filter(Boolean);
    const requestedSegments = requested.split('/').filter(Boolean);
    if (declaredSegments.length !== requestedSegments.length)
        return false;
    return declaredSegments.every((segment, index) => (0, app_base_binding_route_1.appRouteSegmentMatches)(segment, requestedSegments[index]));
}
function normalizeRoutePath(routePath) {
    const parts = routePath.replace(/\\/g, '/').split('/').filter(Boolean);
    return parts.length === 0 ? '/' : `/${parts.join('/')}`;
}
